<div (mouseleave)="contextMenuOpen=false">
  <div class='value-container'>
    @if (footnotes.length > 0 || sourceBox !== null || prevSourceBox !== null) {
      <div>
        <div class="cell-menu-toggle" (click)="toggleContextMenu($event)">
          @if (contextMenuOpen) {
            <i class="fas fa-caret-up pointer"></i>
          }
          @if (!contextMenuOpen) {
            <i class="fas fa-caret-down pointer"></i>
          }
        </div>
        @if (contextMenuOpen) {
          <ul class="dropdown-menu">
            @if (footnotes.length > 0) {
              <li class="header-item"><span >Footnotes</span></li>
            }
            @for (footnote of footnotes; track footnote; let idx = $index) {
              <li>
                <span (click)="clickOpenFootnote($event, idx)">Show Footnote {{idx + 1}}</span>
              </li>
            }
            @if (sourceBox !== null || prevSourceBox !== null) {
              <li class="header-item"><span >Source Document</span></li>
            }
            @if (sourceBox !== null) {
              <li><span (click)="clickOpenSourceBox($event)">Show Source</span></li>
            }
            @if (prevSourceBox !== null) {
              <li><span (click)="clickOpenPreviousSourceBox($event)">Show Source (Previous Period)</span></li>
            }
          </ul>
        }
      </div>
    }
    <div
        [ngClass]="{
          'raw-line-item-label': rawItem,
          'line-item-label': !rawItem,
          'has-source-box-label': sourceBox !== null || prevSourceBox !== null
        }"
      (click)="clickOpenDetail($event)"
      >
      {{ label }}
    </div>
  </div>
  <div [ngClass]="{
    'line-item-value-positive': changeType === 'positive',
    'line-item-value-negative': changeType === 'negative',
    'line-item-value-neutral': changeType === 'neutral'
  }" (click)="clickOpenDetail($event)">
    {{ formattedValue }}
  </div>
  <div [ngClass]="{
    'change-positive': changeType === 'positive',
    'change-negative': changeType === 'negative',
    'change-neutral': changeType === 'neutral'
  }" (click)="clickOpenDetail($event)">
    @if (changeType !== 'negative' && prevValue !== null && !(prevValue === 0 && value === 0)) {
      <i class="fas fa-caret-up"></i>
    }
    @if (changeType === 'negative' && prevValue !== null) {
      <i class="fas fa-caret-down"></i>
    }
    {{ displayPeriodOverPeriodChange(value, prevValue) }}
  </div>
</div>
